/**
 * Exchange.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

 export default {
    attributes: {
        name: {
          type: 'string',
          required: true,
        }
      },
  
  }
  


// WEBPACK FOOTER //
// ./src/models/Iva.js